import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Home from "@/pages/Home";
import ZenScore from "@/pages/ZenScore";
import Businesses from "@/pages/Businesses";
import Partners from "@/pages/Partners";
import Marketplace from "@/pages/Marketplace";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Resources from "@/pages/Resources";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import BankConnectSuccess from "@/pages/BankConnectSuccess";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

import "@/App.css";

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-bg-base text-white antialiased">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/zenscore" element={<ZenScore />} />
            <Route path="/businesses" element={<Businesses />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/bank-connect-success" element={<BankConnectSuccess />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
